import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { Dictionary } from "../../util/collection/Dictionary";
import { EventHandler } from "../../util/event/EventHandler";
/**
 * GameConfigsRequest.ts
 */
export class GameConfigsRequest {
    constructor(url, factory) {
        this.url = url;
        this.factory = factory;
    }
    processRequest() {
        this.processGameConfigs();
    }
    processGameConfigs() {
        this.gameConfigs = new Dictionary();
        let document = this.request.getXML();
        let element = document.getElementsByTagName("GameConfigs")[0];
        let elements = element.getElementsByTagName("Config");
        for (let i = 0; i < elements.length; i++) {
            let config = this.factory.createGameConfig();
            config.setData(elements[i]);
            this.gameConfigs.setValue(config.getId(), config);
        }
    }
    getGameConfigs() {
        return this.gameConfigs;
    }
    onComplete(action, scope) {
        this.completeHandler = new EventHandler(action, scope);
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_XML);
        this.request.setResponseType(RequestConstants.DOCUMENT);
        this.request.onComplete(this.handleSuccess, this);
        this.request.send();
    }
    handleSuccess() {
        this.processRequest();
        this.completeHandler.call(this);
    }
}
//# sourceMappingURL=GameConfigsRequest.js.map